export default __webpack_public_path__ + "5aa9c991cecf6462d98aa5df982221f6.png";